import { render, staticRenderFns } from "./MonacoEditorControl.vue?vue&type=template&id=132ed632&scoped=true&"
import script from "./MonacoEditorControl.vue?vue&type=script&lang=js&"
export * from "./MonacoEditorControl.vue?vue&type=script&lang=js&"
import style0 from "./MonacoEditorControl.vue?vue&type=style&index=0&id=132ed632&prod&lang=scss&scoped=true&"
import style1 from "./MonacoEditorControl.vue?vue&type=style&index=1&id=132ed632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ed632",
  null
  
)

export default component.exports